import React from "react";
import Slide from "react-reveal/Slide";
import Fade from "react-reveal/Fade";

import WorkCard from "./WorkCard";

import { workData } from "./data";

import "./style.css";

function Work() {
  return (
    <div className="work">
      <Fade left>
        <h3 className="work__title">Work Samples</h3>
      </Fade>
      <Slide bottom>
        <div className="work__cards__container">
          {workData.map((val, index) => {
            return <WorkCard data={val} key={"workCard" + index} />;
          })}
        </div>
      </Slide>
    </div>
  );
}

export default Work;
